<template lang="pug">
  v-container
    illustration-state(
      v-if="$get(comments, 'length') === 0"
      title="Aucun commentaire pour l'instant"
      body="Soyez le premier à commenter"
      :illustration="illustration")
    template(v-else)
      v-row.px-0(
        v-for="comment in comments"
        :key="comment.id"
        dense)
        v-col.shrink
          feature-avatar(:src="$get(comment.author.image, `src`)")
        v-col.ml-3
          v-row(dense)
            span.subtitle-1 {{ comment.author.name }}
          v-row(dense)
            div.body-2(style="white-space: break-spaces") {{ comment.content }}
        v-col(:cols="12")
          v-btn(
            :ripple="false"
            text
            small) {{ Now.getTimeAgo({ datetime: comment.createdAt, simplify: true }) }}
          v-btn(
            @click="isLikedByMe(comment) ? onUnlike(comment) : onLike(comment)"
            text
            small
            :color="isLikedByMe(comment) ? 'primary' : undefined") J'aime
          v-btn(
            @click="onGoToComments(comment)"
            text
            small) Répondre
          v-btn(
            @click="remove(comment)"
            outlined
            text
            small) Supprimer
</template>

<script>
import { page } from '@iez/core'
import router, { routeCurrent } from '@iez/core/router/'
import data from '@iez/lib/data/'
import user from '@iez/lib/user/'
import illustration from '@iez/illustrations/PublicDiscussion'
import IllustrationState from '@iez/components/illustration-state/'
import { mdiSend } from '@mdi/js'
import Now from '@iez/features/now/'
import { computed } from '@vue/composition-api'
import UtilityActionState from '@iez/components/utility/action-state/'

const route = {
  path: '/comments/:postOrComment/:postOrCommentId',
  name: 'Comments'
}

export default {
  ...route,

  components: {
    IllustrationState,
    UtilityActionState
  },

  setup () {
    page.topBar.set({
      title: `Commentaires`
    })

    const me = data.me({
      fields: [
        `id`,
        `isAdmin`
      ]
    })

    const isAdmin = computed(
      () => me.value?.isAdmin
    )

    const isMine = comment =>
      comment?.author?.id === user.id

    const canRemove = comment =>
      isAdmin.value || isMine(comment)

    const fields = [
      'id',
      'createdAt',
      'content', {
        author: [
          'id',
          'name', {
            image: [`id`, `src`]
          }
        ],
        likesComments: [
          'id',
          'authorId'
        ],
        comments: [
          'id'
        ]
      }
    ]

    const comments = data.get({
      root: 'comments',
      fields,
      request: {
        order_by: {
          createdAt: `desc`
        },
        where: {
          [`${routeCurrent.params.postOrComment}Id`]: {
            _eq: routeCurrent.params.postOrCommentId
          }
        }
      }
    })

    page.bottomAction.set({
      textInput: {
        label: 'Votre commentaire...',
        max: 400,
        autofocus: !!routeCurrent.query.autofocus,
        action: {
          icon: mdiSend,
          onClick: async ({ content }) => {
            await data.set({
              root: 'comments',
              fields,
              items: [{
                content,
                authorId: user.id,
                [`${routeCurrent.params.postOrComment}Id`]: routeCurrent.params.postOrCommentId
              }]
            })
            page.bottomAction.clearInput()
          }
        }
      }
    })

    const onLike = comment => {
      data.set({
        root: 'likesComments',
        fields: ['id'],
        items: [{
          authorId: user.id,
          commentId: comment.id
        }]
      })
    }

    const onUnlike = comment => {
      data.remove({
        root: 'likesComments',
        ids: comment.likesComments
          .filter(({ authorId }) => authorId === user.id)
          .map(({ id }) => id),
        parents: [{
          root: 'users',
          id: user.id
        }, {
          root: 'comments',
          id: comment.id
        }]
      })
    }

    const isLikedByMe = comment =>
      comment.likesComments.some(({ authorId }) => authorId === user.id)

    const onGoToComments = comment => {
      router.push({
        name: `Comments`,
        params: {
          postOrCommentId: comment.id,
          postOrComment: `comment`
        },
        query: {
          autofocus: true
        }
      })
    }

    const remove = comment => {
      page.confirm({
        title: `Êtes-vous sûr ?`,
        action1: {
          label: `Supprimer`,
          onClick: async () => {
            await data.remove({
              root: 'comments',
              ids: comment.id,
              parents: []
            })
          }
        }
      })
    }
    return {
      comments,
      illustration,
      Now,
      onLike,
      onUnlike,
      isLikedByMe,
      onGoToComments,
      canRemove,
      remove
    }
  }
}
</script>
